module.exports = __webpack_public_path__ + "img/ECU.d7712252.svg";